
import React from 'react';
import { Link } from 'react-router-dom';

const FooterCopyright: React.FC = () => {
  return (
    <div className="mt-12 pt-8 border-t border-gray-800 text-sm text-gray-500">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <p className="mb-4 md:mb-0">
          &copy; {new Date().getFullYear()} OGMAI. All rights reserved.
        </p>
        <div className="hidden md:flex space-x-4">
          <Link to="/terms" className="hover:text-white transition-colors">
            Terms of Use
          </Link>
          <Link to="/privacy" className="hover:text-white transition-colors">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FooterCopyright;
